import React, { createContext, useState } from "react"

export const analysisContext = createContext(null)

function AnalysisProvider({ children }) {
  const [selectedBox, setSelectedBox] = useState({})
  const [slideIndex, setSlideIndex] = useState(0)
  const changeSelectedBox = box => {
    setSelectedBox(box)
  }

  return (
    <analysisContext.Provider
      value={{
        selectedBox,
        slideIndex,
        setSlideIndex,
        changeSelectedBox,
      }}
    >
      {children}
    </analysisContext.Provider>
  )
}

export default AnalysisProvider
